import { notification } from 'antd'
import UserInfoService, { GetUserInfoResponse } from '../../services/UserService'
import * as Sentry from '@sentry/react'
import {UserInfo, resetUserInfo, setUserInfo, setUserInfoLoading} from '../../store/user-info/reducer'
import {Dispatch} from 'redux'

// TODO redux-thunk
export async function getUserInfo(dispatch: Dispatch<AnyType>): Promise<UserInfo | null> {
  let isMounted = true
  dispatch(resetUserInfo())
  dispatch(setUserInfoLoading(true))

  return UserInfoService
    .getUserInfo()
    .then((userInfoResponse: GetUserInfoResponse) => {
      isMounted = true
      dispatch(setUserInfo(userInfoResponse))
      return userInfoResponse
    })
    .catch((error: Error) => {
      if (!isMounted) {
        return null
      }
      notification.error({
        message: 'Ошибка при получении данных пользователя',
        description: error.message,
        duration: 5,
      })
      Sentry.captureException(error)
      dispatch(resetUserInfo())
      return null
    })
    .finally(() => {
      if (!isMounted) {
        return
      }
      dispatch(setUserInfoLoading(false))
    })
}